import React, { Component } from 'react';
import { SafeAreaView, StyleSheet, Text, View } from 'react-native';
import { Button, ButtonTypes } from '../components';
import { IAppStore } from '../HomeWorkouts';
import Theme from '../theme';
import { defaultScale, scaleText } from '../utils/scaling';
import UserDataConsumer from '../utils/UserDataConsumer';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { removeFamilyPlanMember } from './actions';
import { isLeavingFamilyPlanSelector, removeFamilyPlanMemberErrorSelector } from './selector';
import { FormError } from 'fitbeat.react-native-components';

interface IProps {
  t: any,
  navigation: any,
  error: string | undefined;
  isLoading: boolean;
  confirmRemove: (userIdToRemove: string, memberIsBeingRemovedByAdmin: boolean) => void;
}

class ConfirmRemoveComponent extends Component<IProps>{
  constructor(props) {
    super(props);
  }

  public render() {
    const { t, navigation } = this.props;
    const { userToRemove, memberIsBeingRemovedByAdmin } = this.props.navigation.state.params;

    return (
      <SafeAreaView style={styles.container}>
        <View style={styles.contentContainer}>
          <View style={styles.textContainer}>
            <Text style={styles.primaryText}>{memberIsBeingRemovedByAdmin ? t('confirmUnlink', { name: userToRemove.firstname }) : t('confirmRemove')}</Text>
            <Text style={styles.secondaryText}>{memberIsBeingRemovedByAdmin ? t('confirmUnlinkInformation', { name: userToRemove.firstname }) : t('confirmRemoveInformation')}</Text>
          </View>
          <FormError error={this.props.error} color={Theme.GREY_DARK} />

          {memberIsBeingRemovedByAdmin ? (
            <View style={styles.buttonsContainer}>
              <Button
                title={t('cancel')}
                buttonType={ButtonTypes.OUTLINE}
                containerStyle={[styles.cancel]}
                overrideFontStyles={styles.secondaryActionFontStyle}
                onPress={this.props.isLoading ? () => {} : () => navigation.goBack()}
              />
              <Button
                title={t('unlink', { name: userToRemove.firstname })}
                buttonType={ButtonTypes.NORMAL}
                overrideFontStyles={styles.mainActionFontStyle}
                onPress={() => this.props.confirmRemove(userToRemove.uid, true)}
                isLoading={this.props.isLoading}
              />
            </View>
          ) : (
            <View style={styles.buttonsContainer}>
              <Button
                title={t('doNotLeave')}
                buttonType={ButtonTypes.NORMAL}
                contentContainerStyle={styles.declineLeave}
                overrideFontStyles={styles.mainActionFontStyle}
                onPress={this.props.isLoading ? () => {} : () => navigation.goBack()}
              />
              <Button
                title={t('yesLeave')}
                buttonType={ButtonTypes.OUTLINE}
                containerStyle={[styles.acceptLeave]}
                overrideFontStyles={styles.secondaryActionFontStyle}
                onPress={() => this.props.confirmRemove(userToRemove.uid, false)}
                isLoading={this.props.isLoading}
              />
            </View>
          )}
        </View>
      </SafeAreaView>
    )
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Theme.WHITE,
  },
  contentContainer: {
    flex: 1,
    paddingHorizontal: defaultScale(15),
  },
  textContainer: {
    flex: 1,
    justifyContent: 'center'
  },
  primaryText: {
    ...Theme.textStyle.heading
  },
  secondaryText: {
    marginTop: defaultScale(10),
    ...Theme.textStyle.bodyCopyReg,
  },
  acceptLeave: {
    borderColor: Theme.PRIMARY,
    alignItems: 'center',
    marginTop: defaultScale(15),
  },
  mainActionFontStyle: {
    fontFamily: Theme.Weight700,
    fontSize: scaleText(16),
    color: Theme.WHITE,
  },
  declineLeave: {
    width: '100%',
  },
  secondaryActionFontStyle: {
    fontFamily: Theme.Custom700,
    fontSize: scaleText(16),
  },
  cancel: {
    marginBottom: defaultScale(15)
  },
  buttonsContainer: {
    marginBottom: defaultScale(15)
  }
});

const mapStateToProps = (state: IAppStore): Partial<IProps> => {
  return {
    error: removeFamilyPlanMemberErrorSelector(state),
    isLoading: isLeavingFamilyPlanSelector(state),
  };
};

const mapDispatchToProps = (dispatch: any, ownProps: any) => {
  const navigation = ownProps.navigation;
  const userServiceClient = ownProps.user.userServiceClient;
  const setUpInitialUserData = ownProps.user.setUpInitialUserData;
  const userProfileService = ownProps.user.userProfileService;

  return {
    confirmRemove: (userIdToRemove: string, memberIsBeingRemovedByAdmin: boolean) =>
    dispatch(
      removeFamilyPlanMember(
        userServiceClient,
        userProfileService,
        setUpInitialUserData,
        navigation,
        userIdToRemove,
        memberIsBeingRemovedByAdmin,
      )
    ),
  };
};

export const ConfirmRemove = translate(['familyPlan'])(
  UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(ConfirmRemoveComponent))
);
